import { render, staticRenderFns } from "./NavigationMenuItem.vue?vue&type=template&id=73a26c6d&scoped=true"
import script from "./NavigationMenuItem.vue?vue&type=script&lang=js"
export * from "./NavigationMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a26c6d",
  null
  
)

export default component.exports